module.exports = __webpack_public_path__ + "img/levelup-icon-o.c2d4e810.svg";